/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
  /* 01.General */
  "general.copyright": "Myma.ai © 2019 All Rights Reserved.",

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  "user.login-title": "Iniciar sesión",
  "user.register": "Registro",
  "user.forgot-password": "Se te olvidó tu contraseña",
  "user.email": "Email",
  "user.password": "Contraseña",
  "user.forgot-password-question": "¿Contraseña olvidada?",
  "user.fullname": "Nombre completo",
  "user.login-button": "INICIAR SESIÓN",
  "user.register-button": "REGISTRO",
  "user.reset-password-button": "REINICIAR",
  "user.buy": "COMPRAR",
  "user.username": "Nombre de Usuario",

  /* 03.Menú */
  "menu.online": "En línea",
  "menu.offline": "Desconectado",
  "menu.app": "Inicio",
  "menu.default": "Defecto",
  "menu.analytics": "Analítica",
  "menu.ecommerce": "Comercio electrónico",
  "menu.content": "Contenido",
  "menu.pages": "Páginas",
  "menu.data-list": "Lista Datos",
  "menu.thumb-list": "Lista Pulgares",
  "menu.image-list": "Lista Imagen",
  "menu.details": "Detalles",
  "menu.search": "Búsqueda",
  "menu.login": "Iniciar sesión",
  "menu.register": "Registro",
  "menu.forgot-password": "Olvidé mi contraseña",
  "menu.error": "Error",
  "menu.applications": "Aplicaciones",
  "menu.todo": "Notas",
  "menu.survey": "Encuesta",
  "menu.chat": "Chatea",
  "menu.ui": "IU",
  "menu.alerts": "Alertas",
  "menu.badges": "Badges",
  "menu.buttons": "Botones",
  "menu.cards": "Tarjetas",
  "menu.carousel": "Carrusel",
  "menu.charts": "Gráficos",
  "menu.collapse": "Colapso",
  "menu.dropdowns": "Menús Desplegables",
  "menu.editors": "Editores",
  "menu.form-layouts": "Diseños de Formulario",
  "menu.form-components": "Componentes de Formulario",
  "menu.form-validations": "Validaciones de Formulario",
  "menu.icons": "Iconos",
  "menu.input-groups": "Grupos de Entrada",
  "menu.jumbotron": "Jumbotron",
  "menu.modal": "Modal",
  "menu.navigation": "Navegación",
  "menu.popover-tooltip": "Tooltips y Popovers",
  "menu.sortable": "Ordenable",
  "menu.tables": "Tablas",
  "menu.menu": "Menú",
  "menu.subhidden": "Sub Oculto",
  "menu.hidden": "Oculto",
  "menu.visible": "Visible",
  "menu.maps": "Mapas",

  "menu.landingpage": "Página de Destino",
  "menu.multipage-home": "Múltiple Página",
  "menu.singlepage-home": "Una Página",
  "menu.about": "Acerca de",
  "menu.auth-login": "Autenticación",
  "menu.auth-register": "Registro",
  "menu.blog": "Blog",
  "menu.blog-detail": "Detalle del Blog",
  "menu.careers": "Carrera",
  "menu.confirmation": "Confirmación",
  "menu.contact": "Contacto",
  "menu.docs": "Docs",
  "menu.features": "Caracteristicas",
  "menu.prices": "Precios",
  "menu.videos": "Videos",
  "menu.mailing": "Correo",
  "menu.invoice": "Factura",
  "menu.blank-page": "Blank Page",
  "menu.types": "Menu Types",
  "menu.levels": "Menu Levels",
  "menu.third-level-1": "Third Level 1",
  "menu.third-level-2": "Third Level 2",
  "menu.third-level-3": "Third Level 3",

  /* 04.Tableros */
  "dashboards.pending-orders": "Pedidos Pendientes",
  "dashboards.completed-orders": "Pedidos Completados",
  "dashboards.refund-requests": "Petición de Reembolso",
  "dashboards.new-comments": "Nuevos Comentarios",
  "dashboards.sales": "Ventas",
  "dashboards.orders": "Pedidos",
  "dashboards.refunds": "Reembolso",
  "dashboards.recent-orders": "Pedidos Recientas",
  "dashboards.product-categories": "Categorías de Producto",
  "dashboards.cakes": "Tortas",
  "dashboards.tickets": "Entradas",
  "dashboards.calendar": "Calendario",
  "dashboards.best-sellers": "Mejores Vendidos",
  "dashboards.website-visits": "Visitas al sitio web",
  "dashboards.unique-visitors": "Visitantes únicos",
  "dashboards.this-week": "Esta Semana",
  "dashboards.last-week": "La Semana Pasada",
  "dashboards.this-month": "Este Mes",
  "dashboards.conversion-rates": "Medidas de Conversión",
  "dashboards.per-session": "Por Sección",
  "dashboards.profile-status": "Estado del Perfil",
  "dashboards.payment-status": "Estado del Pago",
  "dashboards.work-progress": "Trabajo en Progreso",
  "dashboards.tasks-completed": "Tareas Completadas",
  "dashboards.payments-done": "Pagos Realizados",
  "dashboards.order-stock": "Pedidos - Valores",
  "dashboards.categories": "Categorías",
  "dashboards.quick-post": "Publicación Rápida",
  "dashboards.title": "Título",
  "dashboards.content": "Contenido",
  "dashboards.category": "Categoría",
  "dashboards.save-and-publish": "Guardar y Publicar",
  "dashboards.top-viewed-posts": "Publicaciones Más Vistas",
  "dashboards.posts": "Puestos",
  "dashboards.pending-for-publish": "Pendiente de Publicación",
  "dashboards.users": "Usuarios",
  "dashboards.on-approval-process": "En Proceso de Aprobación",
  "dashboards.alerts": "Alertas",
  "dashboards.waiting-for-notice": "Esperando Aviso",
  "dashboards.files": "Archivos",
  "dashboards.pending-for-print": "Pendiente para imprimir",
  "dashboards.logs": "Troncos",
  "dashboards.gogo": "GOGO",
  "dashboards.magic-is-in-the-details": "LA MAGIA ESTA EN LOS DETALLES",
  "dashboards.yes-it-is-indeed": "¡Si es verdad!",
  "dashboards.advanced-search": "Búsqueda Avanzada",
  "dashboards.toppings": "Coberturas",
  "dashboards.type": "Categoría",
  "dashboards.keyword": "Palabra Clave",
  "dashboards.search": "Búsqueda",
  "dashboards.top-rated-items": "Artículos Mejores Valorados",
  'dashboards.topic': 'Tema',
  /* 05.Esquemas */


  'pages.title.dashboards.analytics': 'Análisis',
  'pages.title.ari': 'Disponibilidad y Tarifas',
  'pages.title.conversations': 'Conversaciones',
  'pages.title.bookings': 'Reservas y Reservaciones',
  'pages.title.tickets': 'Leads y Tickets',
  'pages.title.propinfo': 'Respuestas',
  'pages.title.discounts': 'Descuentos y Promociones',
  'pages.title.finance': 'Finanzas',
  'pages.title.integration': 'Integración',
  'pages.title.admin': 'Administración',

  "pages.add-new": "AGREGAR NUEVO",
  "pages.add-new-modal-title": "Agregar ítem nuevo",
  "pages.display-options": "Opciones de Pantalla",
  "pages.orderby": "Ordenar por : ",
  "pages.product-name": "Nombre del Producto",
  "pages.category": "Categoría",
  "pages.description": "Descripción",
  "pages.status": "Estado",
  "pages.cancel": "Cancelar",
  "pages.submit": "Enviar",
  "pages.delete": "Borrar",
  "pages.another-action": "Otra accion",
  "pages.actions": "ACCIONES",
  "pages.header": "Encabezado",
  "pages.details": "DETALLES",
  "pages.orders": "PEDIDOS",
  "pages.rating": "Clasificación",
  "pages.price": "Precio",
  "pages.ingredients": "Ingredients",
  "pages.is-vegan": "Es Vegano",
  "pages.order-status": "Estado del Pedido",
  "pages.bake-progress": "Progreso de Hornear",
  "pages.popularity": "Popularidad",
  "pages.comments": "Comentarios",
  "pages.error-title": "Vaya, parece que ha ocurrido un error!",
  "pages.error-code": "Código de error",
  "pages.go-back-home": "REGRESAR A INICIO",
  "pages.mailing-info": "Las plantillas de correo utilizan el diseño en línea y el diseño de la tabla para mostrarse bien en varios proveedores de servicios. Para proporcionar una mejor usabilidad, lo incluimos como html regular con dangerouslySetInnerHTML.",
  "pages.invoice-info": "La plantilla de factura tiene una versión de estilo en línea para uso fuera del proyecto, así como la versión React.",
  "pages.react-version": "React Versión",
  "pages.inline-version": "Estilo en Linea Html Versión",

  /* 06.Aplicaciones */

  /* 06.01.Chatea */
  "chat.messages": "Mensajes",
  "chat.contacts": "Contactos",
  "chat.saysomething": "Di algo..",
  /* 06.02.Encuesta */
  "survey.delete": "Borrar",
  "survey.edit": "Edit",
  "survey.add-new": "AGREGAR NUEVO",
  "survey.add-new-title": "Add New Encuesta",
  "survey.title": "Título",
  "survey.category": "Categoría",
  "survey.label": "Etiqueta",
  "survey.status": "Estado",
  "survey.cancel": "Cancelar",
  "survey.submit": "Enviar",
  "survey.another-action": "Otra accion",
  "survey.display-options": "Opciones de Pantalla",
  "survey.orderby": "Ordenar por : ",
  "survey.all-surveys": "Todas las Encuestas",
  "survey.completed-surveys": "Encuestas Completadas",
  "survey.categories": "Categorías",
  "survey.active-surveys": "Encuestas Activas",
  "survey.labels": "Etiquetas",

  /* 06.03.Notas */
  "todo.add-new": "AGREGAR NUEVO",
  "todo.add-new-title": "Añadir Nuevo",
  "todo.title": "Título",
  "todo.detail": "Detalle",
  "todo.category": "Categoría",
  "todo.label": "Etiqueta",
  "todo.status": "Estado",
  "todo.cancel": "Cancelar",
  "todo.submit": "Enviar",
  "todo.action": "Accion",
  "todo.another-action": "Otra accion",
  "todo.display-options": "Opciones de Pantalla",
  "todo.orderby": "Ordenar por : ",
  "todo.all-tasks": "Todas las Tareas",
  "todo.pending-tasks": "Tareas Pendientes",
  "todo.completed-tasks": "Tareas Completadas",
  "todo.categories": "Categorías",
  "todo.labels": "Etiquetas",

  /* 07.IU */

  /* 07.01.Alertas */
  "alert.rounded": "Alerta Redondeado",
  "alert.react-notifications": "React Notificaciones",
  "alert.outline": "Contorno",
  "alert.primary": "Primary",
  "alert.secondary": "Secondary",
  "alert.info": "Info",
  "alert.success": "Success",
  "alert.warning": "Warning",
  "alert.error": "Error",
  "alert.filled": "Lleno",
  "alert.primary-text": "¡Esto es un primary alert—check fuera!",
  "alert.secondary-text": "¡Esto es un secondary alert—check fuera!",
  "alert.success-text": "¡Esto es un success alert—check fuera!",
  "alert.danger-text": "¡Esto es un danger alert—check fuera!",
  "alert.warning-text": "¡Esto es un warning alert—check fuera!",
  "alert.info-text": "¡Esto es un info alert—check fuera!",
  "alert.light-text": "¡Esto es un light alert—check fuera!",
  "alert.dark-text": "¡Esto es un dark alert—check fuera!",
  "alert.default": "Alerta por Defecto",
  "alert.dismissing": "Despido de Alerta",
  "alert.dismissing-text": "¡Santo guacamole! Debes revisar algunos de esos campos a continuación.",
  "alert.dismissing-without-animate-text": "¡Estoy alerta y me pueden despedir sin animarme!",

  /* 07.02.Badges */
  "badge.sizes": "Tamaños",
  "badge.colors": "Colores",
  "badge.outline": "Contorno",
  "badge.links": "Enlaces",
  "badge.counter-badges": "Mostrador Badges",
  "badge.bootstrap-default": "Bootstrap Defecto",
  "badge.primary": "Primary",
  "badge.secondary": "Secondary",
  "badge.success": "Success",
  "badge.danger": "Danger",
  "badge.warning": "Warning",
  "badge.info": "Info",
  "badge.light": "Light",
  "badge.dark": "Dark",

  /* 07.03.Botones */
  "button.default": "Bootstrap Defecto",
  "button.colors": "Colores",
  "button.rounded": "Botones Redondeado",
  "button.outline": "Contorno",
  "button.states": "Estados",
  "button.sizes": "Tamaños",
  "button.button-groups": "Grupos de Botones",
  "button.large-button": "Botón Grande",
  "button.small-button": "Botón Pequeño",
  "button.extra-small-button": "Botón Extra Pequeño",
  "button.block-button": "Botón de Bloqueo",
  "button.active": "Activo",
  "button.disabled": "Discapacitado",
  "button.basic": "Básico",
  "button.toolbar": "Barra de Herramientas",
  "button.nesting": "Anidando",
  "button.vertical-variation": "Variación Vertical",
  "button.checkbox-radio-button": "Checkbox  y Radio Buttons",
  "button.checkbox": "Checkbox",
  "button.radio": "Radio",
  "button.radio-button": "Radio Button",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.success": "Success",
  "button.danger": "Danger",
  "button.warning": "Warning",
  "button.info": "Info",
  "button.light": "Light",
  "button.dark": "Dark",
  "button.states-text": "Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.",
  "button.click-here": "Haga clic aquí",
  "button.states-text-alternate": "Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.",
  "button.primary-link": "Primary Enlace",
  "button.link": "Enlace",
  "button.primary-button": "Primary Botón",
  "button.button": "Botón",
  "button.left": "Izquierda",
  "button.middle": "Centro",
  "button.right": "Derecha",
  "button.dropdown": "Desplegable",
  "button.dropdown-link": "Enlace Desplegable",

  /* 07.04.Tarjetas */
  "cards.icon-card": "Tarjeta de Icono",
  "cards.image-card": "Tarjeta de Imagen",
  "cards.image-overlay-card": "Tarjeta de Superposición de Imágenes",
  "cards.image-card-list": "Lista de Tarjetas de Imagen",
  "cards.tab-card": "Tarjeta de Tab",
  "cards.user-card": "Tarjeta de Usuario",

  /* 07.05.Carrusel */
  "carousel.basic": "Carrusel Básico",
  "carousel.single": "Carrusel Sólo",
  "carousel.without-controls": "Carrusel sin Control",

  /* 07.06.Gráficos */
  "charts.line": "Gráfico de Linea",
  "charts.polar": "Gráfico de Polar",
  "charts.area": "Gráfico de Área",
  "charts.scatter": "Gráfico de Dispersión",
  "charts.bar": "Gráfico de Barras",
  "charts.radar": "Gráfico de Radar",
  "charts.pie": "Gráfico de Circular",
  "charts.doughnut": "Gráfico de Rosquilla",
  "charts.shadow": "Sombra",
  "charts.no-shadow": "Sin Sombra",

  /* 07.07.Colapso */
  "collapse.basic": "Básico",
  "collapse.toggle": "Palanca",
  "collapse.accordion": "Acordeón",
  "collapse.controlled": "Revisado",
  "collapse.uncontrolled": "Sin Control",

  /* 07.08.Desplegables */
  "dropdowns.basic": "Básico",
  "dropdowns.controlled": "Revisado",
  "dropdowns.uncontrolled": "Sin Control",
  "dropdowns.dropdown": "Desplegable",
  "dropdowns.header": "Encabezado",
  "dropdowns.action": "Accion",
  "dropdowns.another-action": "Otra accion",
  "dropdowns.right": "Derecha",
  "dropdowns.left": "Izquierda",
  "dropdowns.drop-directions": "Direcciones de drop",
  "dropdowns.dropright": "Drop Derecha",
  "dropdowns.dropleft": "Drop Izquierda",
  "dropdowns.small-button": "Botón Pequeño",
  "dropdowns.large-button": "Botón Grande",
  "dropdowns.sizing": "Dimensionamiento",
  "dropdowns.split-button": "Botones Desplegables",
  "dropdowns.dropup": "Dropup",

  /* 07.09.Editores */
  "editors.draftjs": "Draft.js",
  "editors.quill-standart": "Quill Estándar",
  "editors.quill-bubble": "Quill Burbuja",

  /* 07.10.Formularios */
  "forms.basic": "Básico",
  "forms.email": "Email",
  "forms.email-muted": "Nunca compartiremos tu email con nadie más.",
  "forms.password": "Contraseña",
  "forms.submit": "Enviar",
  "forms.horizontal": "Horizontal",
  "forms.radios": "Radios",
  "forms.first-radio": "Primero radio",
  "forms.second-radio": "Segundo radio",
  "forms.third-radio-disabled": "Tercera radio deshabilitada",
  "forms.checkbox": "Checkbox",
  "forms.signin": "Registrarse",
  "forms.top-labels-over-line": "Etiquetas Superiores Sobre la Línea",
  "forms.tags": "Etiquetas",
  "forms.date": "Fecha",
  "forms.state": "Estado",
  "forms.top-labels-in-input": "Etiquetas Superiores Sobre la Entrada",
  "forms.email-u": "EMAIL",
  "forms.password-u": "CONTRASEÑA",
  "forms.tags-u": "ETIQUETAS",
  "forms.date-u": "FECHA",
  "forms.state-u": "ESTADO",
  "forms.grid": "Cuadrícula de Formulario",
  "forms.address": "Dirección",
  "forms.address2": "Dirección 2",
  "forms.city": "Ciudad",
  "forms.city-message": "Por favor seleccione una ciudad!",
  "forms.state-message": "Por favor seleccione un estado!",
  "forms.zip": "Código Postal",
  "forms.signup": "Regístrate",
  "forms.inline": "Inline",
  "forms.validation": "Validación",
  "forms.default": "Defecto",
  "forms.firstname": "Nombre de Pila",
  "forms.firstname-message": "¡Por favor, introduzca su nombre de pila!",
  "forms.lastname": "Apellido",
  "forms.lastname-message": "¡Por favor ingrese su apellido!",

  /* 07.11.Componentes */
  "form-components.custom-inputs": "Entrada Personalizada",
  "form-components.checkboxes": "Checkboxes",
  "form-components.radios": "Radios",
  "form-components.inline": "Inline",
  "form-components.react-select": "React Select",
  "form-components.state-single": "Estado Soltero",
  "form-components.state-multiple": "Estado Múltiple",
  "form-components.react-autosuggest": "React Autosuggest",
  "form-components.date-picker": "Selector de Fechas",
  "form-components.date": "Fecha",
  "form-components.date-range": "Rango de Fechas",
  "form-components.date-with-time": "Fecha con Hora",
  "form-components.embedded": "Incrustado",
  "form-components.dropzone": "Dropzone",
  "form-components.drop-files-here": "Soltar Archivos Aquí",
  "form-components.tags": "Etiquetas",
  "form-components.switch": "Cambiar",
  "form-components.primary": "Primary",
  "form-components.secondary": "Secondary",
  "form-components.primary-inverse": "Primary Inverso",
  "form-components.secondary-inverse": "Secondary Inverso",
  "form-components.slider": "Deslizador",
  "form-components.double-slider": "Doble Deslizador",
  "form-components.single-slider": "Único Deslizador",
  "form-components.rating": "Clasificación",
  "form-components.interactive": "Interactivo",
  "form-components.readonly": "Solo Lectura",
  "form-components.type-a-cake": "Escribe un pastel",
  "form-components.start": "Comienzo",
  "form-components.end": "Fin",
  "form-components.tables": "Tablas",
  /* 07.12.Iconos */
  "icons.simplelineicons": "Simple Line Iconos",
  "icons.iconsmind": "Iconsmind Iconos",

  /* 07.13.Grupos de Entrada */
  "input-groups.basic": "Básico",
  "input-groups.sizing": "Dimensionamiento",
  "input-groups.small": "Pequeño",
  "input-groups.default": "Defecto",
  "input-groups.large": "Grande",
  "input-groups.checkboxes-and-radios": "Checkboxes y radios",
  "input-groups.multiple-inputs": "Entradas Múltiples",
  "input-groups.first-and-last-name": "Nombre y apellido",
  "input-groups.multiple-addons": "Complementos Múltiples",
  "input-groups.button-addons": "Complementos Botón",
  "input-groups.button": "Botón",
  "input-groups.buttons-with-dropdowns": "Botones y Desplegables",
  "input-groups.dropdown": "Desplegable",
  "input-groups.header": "Encabezado",
  "input-groups.action": "Accion",
  "input-groups.another-action": "Otra accion",
  "input-groups.custom-select": "Personalizada Select",
  "input-groups.options": "Opciones",
  "input-groups.choose": "Escoger...",
  "input-groups.custom-file-input": "Entrada de Archivo Personalizada",

  /* 07.14.Jumbotron */
  "jumbotron.hello-world": "¡Hola Mundo!",
  "jumbotron.lead": "Esta es una unidad de héroe simple, un componente de estilo jumbotron simple para llamar la atención extra al contenido o información destacados.",
  "jumbotron.lead-detail": "Utiliza clases de utilidad para tipografía y espaciado para espaciar el contenido dentro del contenedor más grande.",
  "jumbotron.learn-more": "Aprende más",

  /* 07.15.Modal */
  "modal.basic": "Básico",
  "modal.modal-title": "Título Modal",
  "modal.launch-demo-modal": "Lanzar Demo Modal",
  "modal.scrolling-long-content": "Contenido de Desplazamiento Largo",
  "modal.backdrop": "Fondo",
  "modal.backdrop-value": "Valor de Fondo",
  "modal.right-modal": "Derecha Modal",
  "modal.launch-right-modal": "Launch Derecha Modal",
  "modal.nested-modal": "Modal Anidado",
  "modal.size": "Tamaño",
  "modal.launch-large-modal": "Lanzar Grande Modal",
  "modal.launch-small-modal": "Lanzar Pequeño Modal",

  /* 07.16.Navegación */
  "nav.basic": "Navegación Básico",
  "nav.active": "Activo",
  "nav.disabled": "Discapacitado",
  "nav.disabled-link": "Enlace Discapacitado",
  "nav.link": "Enlace",
  "nav.longer-link": "Enlace de navegación más largo",
  "nav.another-link": "Otro Enlace",
  "nav.right": "Derecha",
  "nav.dropdown": "Desplegable",
  "nav.header": "Encabezado",
  "nav.action": "Accion",
  "nav.another-action": "Otra accion",
  "nav.horizontal-alignment": "Alineación Horizontal",
  "nav.vertical-alignment": "Alineación Vertical",
  "nav.pills": "Navegación Píldoras",
  "nav.fill-justify": "Navegación Llenar y Justify",
  "nav.pills-dropdowns": "Nav Pills with Dropdowns",
  "nav.pagination-basic": "Paginación Básico",
  "nav.pagination-sizing": "Paginación Dimensionamiento",
  "nav.large": "Grande",
  "nav.small": "Pequeño",
  "nav.center": "Centro",
  "nav.pagination-alignment": "Alineación de Paginación",
  "nav.breadcrumb-basic": "Migas de Pan Básico",

  /* 07.17.Tooltips y Popovers */
  "popover-tooltip.popover": "Popovers",
  "popover-tooltip.tooltip": "Tooltips",

  /* 07.18.Ordenable */
  "sortable.columns": "Clasificar Columnas",
  "sortable.basic": "Básico",
  "sortable.handles": "Handles",

  /* 07.19.Maps */
  "maps.google": "Google",
  "maps.yandex": "Yandex",

  /* 07.20.Tables */
  "table.bootstrap-tables": "Tablas Bootstrap",
  "table.bootstrap-basic": "Tablas Básicas",
  "table.bootstrap-striped": "Cebreadas",
  "table.bootstrap-bordered": "Tablas Con Bordes",
  "table.bootstrap-borderless": "Tablas Sin Bordes",
  "table.bootstrap-hoverable": "Tablas dinámicas",
  "table.bootstrap-responsive": "Tablas Responsive",
  "table.react-tables": "Tablas React",
  "table.react-pagination": "Paginación",
  "table.react-scrollable": "Tablas Con Voluta",
  "table.react-advanced": "Filtro, Longitud y Salto",


  /* Property Info */
  'property-info.faq': 'Preguntas Frecuentes',
  'property-info.documents': 'Documentos',
  'property-info.publish-ai': 'Publicar IA',
  'property-info.pre-built-templates': 'Plantillas Preconstruidas',
  'property-info.room-types': 'Tipos de Habitaciones',
  'property-info.about-property': 'Acerca de la propiedad',
  'property-info.about-properties': 'Acerca de las propiedades',
  'property-info.facilities-services': 'Instalaciones y servicios',
  'property-info.property-facilities': 'Instalaciones de la propiedad',
  'property-info.room-amenities': 'Servicios en la habitación',
  'property-info.property-contact': 'Contacto de la propiedad',
  'property-info.property-activities': 'Actividades de la propiedad',
  'property-info.property-location': 'Ubicación de la propiedad',
  'property-info.about-rooms': 'Acerca de las habitaciones',
  'property-info.about-sites': 'Acerca de los sitios',
  'property-info.special-emergencies': 'Emergencias',
  'property-info.gallery': 'Galería',
  'property-info.policies': 'Políticas',
  'property-info.nearby': 'Cercana',
  'property-info.transport': 'Transporte',
  'property-info.location': 'Localización',
  'property-info.about-rhproperty': 'Acerca de la casa de retiro',
  'property-info.related-topics': 'Temas relacionados',
  'property-info.assistant-options': 'Opciones de asistente',
  'property-info.restaurant-assistant-information': 'Información del restaurante',
  'property-info.restaurant-assistant-options': 'Mensaje de bienvenida',
  'property-info.channel-messages': 'Mensajes de canal',
  'property-info.icon.gallery': 'Galería de iconos',
  'property-info.copilot': 'Copiloto',
  'property-info.sprint': 'pique',
  'property-info.home-information': 'Inicio Información',
  'property-info.loction': 'Ubicaciones',
  'property-info.rooms-and-images': 'Habitaciones e Imágenes',
  'property-info.trainig-data': 'Datos de entrenamiento',
  'property-info.flows': 'Flujos',
  'property-info.add-your-own': 'Añade tu propio',
  'property-info-utility-miscellaneous': 'Misceláneos',
  'property-info-utility-payment': 'Pagos',
  'property-info-utility-broadband': 'Banda ancha',
  'property-info-utility-emergency': 'Emergencia',
  'property-info-utility-mobile': 'Móvil',
  'property-info-utility-moving': 'Moviente',

  /** Rate & Promo */
  'rate-promo.rate-plans': 'Planes de tarifas',
  'rate-promo.rate-plan-addons': "Complementos",
  'rate-promo.rate-plan-promos': 'Promociones',

  'title.property-information': 'Información de la propiedad',

  'property.message': 'Mensaje',
  'property.example': 'Ejemplo',
  'property.link': 'Enlaces',
  'property.image-carousel': 'Carrusel de imágenes',
  'property.Title': 'Título',
  'property.SubTitle': 'Subtítulo',

  'property.add-invoke-api': 'Invocar API',
  'property.add-message-button': 'Agregar mensajes',
  'property.add-img-button': 'Añadir imágenes',
  'property.add-link-button': 'Añadir enlace',
  'property.add-herocard-button': 'Agregar tarjeta de héroe',
  'property.add-api-button': 'Agregar botones',

  'menu.settings': 'Configuraciones',
  'menu.workflows': 'Flujos de trabajo',
  'menu.product_services': 'Productos y Servicios',
  'menu.product_recommander': 'Recomendador de Productos',
  'menu.digital_guide_book': 'Libro Guía Digital',
  'menu.welcome_message': 'Mensaje de Bienvenida',

  'menu.about-property': 'Acerca de la propiedad',
  'menu.property-facilities': 'Instalaciones de la propiedad',
  'menu.room-amenities': 'Servicios en la habitación',
  'menu.property-contact': 'Contacto de la propiedad',
  'menu.about-rooms': 'Acerca de las habitaciones',
  'menu.special-emergencies': 'Emergencias',
  'menu.ari': 'Disponibilidad y tarifas',
  'menu.conversations': 'Conversaciones',
  'menu.conversations.unified-inbox': 'Unificado Bandeja de entrada',
  'menu.conversations.active': 'Chats activos',
  'menu.conversations.archives': 'Archivo',
  'menu.conversations.missed-responses': 'Respuestas perdidas',
  'menu.conversations.ticket': 'Entradas',
  'menu.conversations.reply-templates': 'Plantillas de respuesta',
  'menu.bookings': 'Reservas y reservas',
  'menu.tickets': 'Leads y entradas',
  'menu.propinfo': 'Centro de conocimiento',
  'menu.rate-promos': 'Tarifas y promociones',
  'menu.finance': 'Finanzas',
  'menu.integration': 'Conectar',
  'menu.admin': 'Admin y seguridad',
  'menu.favourites': 'Favoritos',
  'menu.recommender': 'Flujo de conversación',
  'menu.assistant-setup': 'Configuración del asistente',
  'menu.show-filter': 'filtros',
  'menu.new': 'Nuevo',
  'menu.admin-insights': 'Información del administrador',
  'menu.super-admin': 'Gran administrador',
  'menu.groups': 'Grupos',
  'menu.properties': 'Propiedades',
  'menu.service-provider': 'Proveedores de servicios',
  'menu.spaces': 'Espacios',
  'menu.channel': 'Canales',
  'menu.application': 'Aplicaciones',
  'menu.content-manager': 'Gestor de Contenido',
  'menu.events-calendar': 'Calendario de Eventos',
  'menu.appearance-settings': 'Apariencia y Configuración',
  'menu.help': 'Ayuda',

  'dashboards.space-booking': 'Reserva de espacio',
  'dashboards.gift-voucher': 'Vales regalo',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'De',
  'dashboards.to': 'A',
  'dashboards.active-groups': 'Grupos activos',
  'dashboards.active-properties': 'Propiedades activas',
  'dashboards.live-properties': 'Propiedades vivas',
  'dashboards.properties-going': 'Propiedades en funcionamiento por rango de fechas',
  'dashboards.start-date': 'Fecha de inicio',
  'dashboards.end-date': 'Fecha de finalización',




  'dashboards.previous-month': 'Mes anterior',
  'dashboards.yeartodate': 'El año hasta la fecha',
  'dashboards.lastyear': 'dashboardss.lastyear',
  'dashboards.last-7-days': 'Los últimos 7 días',
  'dashboards.last-30-days': 'Últimos 30 días',
  'dashboards.last-60-days': 'Últimos 60 días',
  'dashboards.last-90-days': 'Últimos 90 días',
  'dashboards.digital-assistant-engagement': 'Compromiso del asistente digital',
  'dashboards.total-overnight-conversations': 'Conversaciones totales y nocturnas (de 7 p. m. a 7 a. m.)',
  'dashboards.common-asked': 'Preguntas más frecuentes',
  'dashboards.website-visitor-asking': 'Cosas sobre las que preguntan los visitantes del sitio web',
  'dashboards.visit-country': 'Visita al sitio web por país',
  'dashboards.visit-traffic': 'País del tráfico del sitio web',
  'dashboards.rooms-product': 'Habitaciones y Productos',
  'dashboards.popular-room-product': 'Habitaciones y productos populares',

  'dashboards.messenger-stats': 'Elementos populares del menú',
  'dashboards.messenger-stats-topic-view': 'Estadísticas sobre vistas de elementos del menú',
  'dashboards.messenger-stats-visits': 'Vistas de elementos de menú',
  'dashboards.opening-menu-items': 'Número de visitantes del sitio web que abren elementos del menú',

  'dashboards.number-totalavatarclick': 'Clics de avatar totales',

  'dashboards.clicks': 'Clics',
  'dashboards.leads': 'Dirige',
  'dashboards.hours': 'Horas',
  'dashboards.minutes': 'Minutos',

  'dashboards.ai-chatbot': 'Chatbot de IA',
  'dashboards.compendium': 'Compendio',
  'dashboards.compendium-digital-usage': 'Uso del compendio digital',
  'dashboards.compendium-unique-visits': 'Visitas únicas',
  'dashboards.compendium-opening-menu-items': 'Número de elementos del menú vistos',
  'dashboards.compendium-total-digital-clicks': 'Clics totales del compendio digital',

  'property.delete': 'Borrar',
  'menu.dashboards': 'Perspectivas',
  'menu.userroles': 'Usuarios y roles',
  'menu.ratebookings': 'Tarifas y reservas',
  'dashboards.engagement-time': 'Tiempo de participación del asistente digital',
  'dashboards.conversations-minutes': 'Minutos totales y minutos de conversaciones durante la noche (de 7:00 p. m. a 7:00 a. m.)',
  'dashboards.visitor-questions': 'Preguntas de los visitantes',
  'dashboards.recent-queries': 'Consultas recientes',
  'dashboards.visitor-saying': 'Lo que sus visitantes le dicen al Asistente digital',
  'dashboards.contacts-prechatform-leavemessage': 'Contactos almacenados desde el formulario previo al chat y dejar mensaje',
  'dashboards.percentage-accuracy': 'Comprensión de la precisión',
  'dashboards.percentage-conversion': 'Conversión de tráfico del sitio web a chat',
  'dashboards.percentage-avatarclick': 'Tráfico del sitio web a clics de Avatar',
  'dashboards.percentage-negativefeedback': 'Comentarios negativos como porcentaje de clics de Avatar',
  'dashboards.percentage-amenties': 'Consultas de servicios',
  'dashboards.percentage-booking': 'Consultas de reserva',
  'dashboards.percentage-webchats': 'Chats en el sitio web',
  'dashboards.percentage-facebookchat': 'Chats de Facebook',
  // 'dashboards.number-webchattime': 'Tiempo total de chat web',
  'dashboards.number-webchattime': 'Tiempo total de conversación',
  'dashboards.number-totalconversation': 'Conversaciones Total',
  'dashboards.number-averagetimeconversation': 'Tiempo Promedio Por Conversación',
  'dashboards.number-websiteconversation': 'Conversaciones del sitio web',
  'dashboards.number-facebookconversation': 'Conversaciones de Facebook',
  'dashboards.number-estimatedtimesaving': 'Ahorro de tiempo estimado',
  'dashboards.number-googlemapsconversation': 'Conversaciones de Google Maps',
  'dashboards.number-whatsappconversation': 'Conversaciones de WhatsApp',
  'dashboards.number-instagramconversation': 'Conversaciones de Instagram',
  'dashboards.number-agentconversation': 'Conversaciones de agentes',
  'dashboards.number-amenityqueries': 'Consultas de servicios',
  'dashboards.number-bookingenquiries': 'Consultas de reserva',
  'dashboards.number-groupbookingenquiries': 'Consultas de reserva de grupo',
  'dashboards.number-eventenquiries': 'Consultas de eventos',
  'dashboards.number-longstayenquiries': 'Consultas de Larga Estancia',
  'dashboards.number-totaltickets': 'Entradas',
  'dashboards.number-returncustomer': 'Cliente de devolución',
  'dashboards.number-redirects': 'Sitio web Redirecciones',
  'dashboards.number-bookingengineleads': 'Clientes potenciales del motor de reservas',
  'dashboards.number-roomnightsreferred': "Noches de habitación recomendadas",
  'dashboards.number-revenuereferred': "Ingresos referidos",

  'menu.bookingsmenu': 'Réservations',
  'menu.guests': 'Información del huésped',
  'menu.whatsnew': "Qué hay de nuevo",

  'menu.formbuilder': 'Creador de formularios',
  'forms.forms-title': 'Forma',

  'menu.virtualfrontdesk': 'Recepción virtual',
  'menu.guestservice': 'Servicios de invitado',
  'virtual-front.common-questions': "Preguntas comunes",
  'virtual-front.add-on-upsells': "Complementos & ventas adicionales",
  'virtual-front.service-order': "Orden de servicio",
  //'virtual-front.guest-service-add-on-upsells': "Servicios para huéspedes y complementos",
  'virtual-front.guest-service-add-on-upsells': "Libro de visitas digital",
  'virtual-front.outbound': "Saliente",
  'virtual-messenger': "Mensajera",

  'missed-response.missed-response-title': "Título de respuesta perdida",
};
